import dataLayerHelper from '../helpers/dataLayer';

const orderForm = {
  initialize() {
    $('body').on('submit', '.js-order-form', (event) => {
      const quickAdd = event.currentTarget.getAttribute('data-quick-add') === '1';

      if (quickAdd) {
        event.preventDefault();

        this.sendAjax(event.currentTarget);
      }

      this.trackAddToCart(event.currentTarget);
    });
  },

  sendAjax(formElement) {
    const formData = new FormData(formElement);

    const submitButton = formElement.querySelector('[type="submit"]');

    const setDisabledState = (state) => {
      if (submitButton) {
        submitButton[state ? 'setAttribute' : 'removeAttribute']('disabled', 'disabled');
      }
    };

    const setText = (text) => {
      if (submitButton) {
        submitButton.textContent = text;
      }
    };

    const setDangerStyle = (state) => {
      if (submitButton) {
        submitButton.className = submitButton.className.replace(state ? /btn--positive/g : /btn--primary/g, '');
        submitButton.className += ` ${state ? 'btn--primary' : 'btn--positive'}`;
      }
    };

    setDisabledState(true);
    setDangerStyle(false);

    $.ajax({
      url: formElement.getAttribute('action'),
      type: formElement.getAttribute('method'),
      data: formData,
      processData: false,
      contentType: false,
      success: () => {
        setText(formElement.getAttribute('data-quick-add-success'));

        setTimeout(() => {
          setText(formElement.getAttribute('data-quick-add-default'));
        }, 3000);
      },
      error: () => {
        setText(formElement.getAttribute('data-quick-add-error'));
        setDangerStyle(true);
      },
      complete: () => {
        setDisabledState(false);
      },
    });
  },

  trackAddToCart(formElement) {
    if (!formElement.getAttribute('data-gtm-product')) {
      return;
    }

    const product = JSON.parse(formElement.getAttribute('data-gtm-product'));

    const quantityElement = formElement.querySelector('[name="quantity"]');

    if (quantityElement) {
      product.quantity = parseInt(quantityElement.value, 10);
    }

    dataLayerHelper.addProduct(product);
  },
};

export default orderForm;
